import { render, staticRenderFns } from "./FreeSwap.vue?vue&type=template&id=673dd610&scoped=true&"
import script from "./FreeSwap.vue?vue&type=script&lang=js&"
export * from "./FreeSwap.vue?vue&type=script&lang=js&"
import style0 from "./FreeSwap.vue?vue&type=style&index=0&id=673dd610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673dd610",
  null
  
)

export default component.exports